import { Link } from 'react-router-dom';
import { Eye, Brain, Sigma, Shield, ArrowRight, Calc, Bolt, Calendar } from '../components/Icons.jsx';

const sections = [
  {
    id: 'vr',
    label: 'Skills Arena',
    code: 'VR',
    icon: Eye,
    drills: [
      { tag: 'VR', icon: Eye, title: 'Reading Lab', desc: 'Three speed-reader drills — chunking, sub-vocalisation, and memory recall. Build the reflex of fast, accurate reading.', link: '/reading-lab', live: true },
      { tag: 'VR', icon: Eye, title: 'Noun / Number Radar', desc: 'Train the scan-and-retrieve reflex. Spot the target word or number in a sea of distractors under 60 seconds.', link: '/drill/chunk', live: true },
      { tag: 'VR', icon: Eye, title: 'Inference Builder', desc: 'UCAT-style true / false / can\'t tell with full per-question rationale. Builds the inference layer.', link: '/drill/inference', live: true }
    ]
  },
  {
    id: 'dm',
    label: 'Decision Dynamo',
    code: 'DM',
    icon: Brain,
    drills: [
      { tag: 'DM', icon: Brain, title: 'Venn Architect', desc: 'Translate prose into Venn region counts.', link: '/drill/venn', live: true },
      { tag: 'DM', icon: Sigma, title: 'Shape Equations', desc: 'Simultaneous equations as shapes. Quickfire with 3 levels.', link: '/drill/shape', live: true },
      { tag: 'DM', icon: Brain, title: 'Syllogisms', desc: 'Single-conclusion + UCAT 5-statement modes with partial credit.', link: '/drill/syllogisms', live: true },
      { tag: 'DM', icon: Brain, title: 'Probability Reasoning', desc: "Single events, AND/OR, complement, conditional, EV and odds.", link: '/drill/probability', live: true }
    ]
  },
  {
    id: 'qr',
    label: 'Number Ninja',
    code: 'QR',
    icon: Calc,
    drills: [
      { tag: 'QR', icon: Calc, title: 'Conversion Gauntlet', desc: 'Currency, units, percentages — and UCAT-style speed/distance/time MCQs.', link: '/drill/conversion', live: true },
      { tag: 'QR', icon: Brain, title: 'Mental Arithmetic', desc: 'Mixed +, −, ×, ÷ at speed. No calculator.', link: '/drill/mental', live: true },
      { tag: 'QR', icon: Calc, title: 'Numpad Trainer', desc: 'On-screen + physical numpad practice with 3 levels.', link: '/drill/numpad', live: true },
      { tag: 'QR', icon: Bolt, title: 'Data Probability', desc: 'Two-way tables, frequency tables, tree diagrams, Bayes-style.', link: '/drill/data-prob', live: true }
    ]
  },
  {
    id: 'sjt',
    label: 'Scenario Sensei',
    code: 'SJT',
    icon: Shield,
    drills: [
      { tag: 'SJT', icon: Shield, title: 'Decision Profiler', desc: 'Diagnostic that maps your decision-making across 5 axes and shows exactly where your SJT marks are leaking. Per-question breakdown at the end.', link: '/drill/sjt-profiler', live: true },
      { tag: 'SJT', icon: Shield, title: 'Near-Miss Trainer', desc: 'Adjacent-rating MCQs that drill the partial-credit decision worth 4–6 marks per real SJT.', link: '/drill/sjt-near-miss', live: true },
      { tag: 'SJT', icon: Shield, title: 'GMC & GDC Standards', desc: 'Match scenarios to the right GMC domain or GDC principle.', link: '/drill/sjt-standards', live: true },
      { tag: 'SJT', icon: Shield, title: 'Social Media & AI in Healthcare', desc: 'UCAT-style appropriateness MCQs on GMC social-media and AI guidance.', link: '/drill/sjt-social-ai', live: true },
      { tag: 'SJT', icon: Shield, title: 'Outcomes for Graduates & Safe Practitioner', desc: 'GMC Outcomes for Graduates + GDC Safe Practitioner Framework.', link: '/drill/sjt-outcomes', live: true }
    ]
  }
];

export default function Practice() {
  return (
    <>
      <div className="page-head">
        <h1>Practice</h1>
        <p className="subtitle">Targeted drills per UCAT subtest.</p>
      </div>

      <Link to="/drill/daily-question" className="card" style={{
        display: 'flex', alignItems: 'center', gap: 14, marginBottom: 14, padding: '16px 20px',
        textDecoration: 'none', color: 'inherit',
        background: 'linear-gradient(135deg, #0891b2, #0e7490)',
        border: 'none'
      }}>
        <div style={{ width: 44, height: 44, borderRadius: 10, background: 'rgba(255,255,255,0.18)', display: 'grid', placeItems: 'center', flexShrink: 0 }}>
          <Calendar width="22" height="22" />
        </div>
        <div style={{ flex: 1, color: '#fff' }}>
          <div style={{ fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', opacity: 0.85 }}>Daily</div>
          <strong style={{ fontSize: 16, color: '#fff' }}>Question of the day</strong>
          <p style={{ margin: '2px 0 0', fontSize: 13.5, color: '#cffafe' }}>One UCAT question per day — VR, DM, QR and SJT rotating. A 2-minute daily habit that covers every reasoning style.</p>
        </div>
        <ArrowRight width="18" height="18" style={{ color: '#fff', flexShrink: 0 }} />
      </Link>

      <Link to="/videos" className="card" style={{
        display: 'flex', alignItems: 'center', gap: 14, marginBottom: 24, padding: '16px 20px',
        textDecoration: 'none', color: 'inherit',
        background: 'linear-gradient(135deg, var(--feature-from), var(--feature-via))',
        border: 'none'
      }}>
        <div style={{ width: 44, height: 44, borderRadius: 10, background: 'rgba(255,255,255,0.18)', display: 'grid', placeItems: 'center', flexShrink: 0 }}>
          <Eye width="22" height="22" />
        </div>
        <div style={{ flex: 1, color: '#fff' }}>
          <div style={{ fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', opacity: 0.85 }}>New</div>
          <strong style={{ fontSize: 16, color: '#fff' }}>UCAT free videos</strong>
          <p style={{ margin: '2px 0 0', fontSize: 13.5, color: '#e9d5ff' }}>17 short teaching videos from the Medic Mind YouTube channel — all subtests.</p>
        </div>
        <ArrowRight width="18" height="18" style={{ color: '#fff', flexShrink: 0 }} />
      </Link>

      {sections.map((s) => (
        <section key={s.id} id={s.id} className="subtest-section">
          <div className="subtest-head">
            <span className="sec-icon"><s.icon width="22" height="22" /></span>
            <div>
              <h2>{s.label}</h2>
              <div className="sub-label">({s.code})</div>
            </div>
          </div>
          <div className="drill-grid">
            {s.drills.map((d) => (
              <DrillCard key={d.title} drill={d} />
            ))}
          </div>
        </section>
      ))}
    </>
  );
}

function DrillCard({ drill }) {
  const Inner = (
    <>
      <div className="row">
        <span className="cat"><drill.icon width="16" height="16" />{drill.tag}</span>
        <span className={`pill ${drill.live ? 'pill-live' : 'pill-teal'}`}>{drill.live ? 'Live' : 'Coming soon'}</span>
      </div>
      <h3>{drill.title}</h3>
      <p>{drill.desc}</p>
      {drill.link ? (
        <Link to={drill.link} className="btn btn-primary">Start <ArrowRight width="16" height="16" /></Link>
      ) : (
        <button className="btn btn-secondary" disabled style={{ opacity: 0.6, cursor: 'not-allowed' }}>Start <ArrowRight width="16" height="16" /></button>
      )}
    </>
  );
  return <div className="drill-card">{Inner}</div>;
}
